module.exports = __webpack_public_path__ + "static/media/kids_53.adb45efa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_53.jpg
// module id = 5909
// module chunks = 0